import { render, staticRenderFns } from "./user.vue?vue&type=template&id=746b0fb9&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.css?vue&type=style&index=0&id=746b0fb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b0fb9",
  null
  
)

export default component.exports